export default __webpack_public_path__ + "static/media/logo08.ce0d8875.svg";